import { render, staticRenderFns } from "./dialog-end-game.vue?vue&type=template&id=774bb6b6"
import script from "./dialog-end-game.vue?vue&type=script&lang=js"
export * from "./dialog-end-game.vue?vue&type=script&lang=js"
import style0 from "./dialog-end-game.vue?vue&type=style&index=0&id=774bb6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports